// extracted by mini-css-extract-plugin
export default {"content":"clinicallayout_content__E5a06"};